
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGInspectionValuesGrid extends Serenity.EntityGrid<MFGInspectionValuesRow, any> {
        protected getColumnsKey() { return 'Production.MFGInspectionValues'; }
        protected getDialogType() { return MFGInspectionValuesDialog; }
        protected getIdProperty() { return MFGInspectionValuesRow.idProperty; }
        protected getInsertPermission() { return MFGInspectionValuesRow.insertPermission; }
        protected getLocalTextPrefix() { return MFGInspectionValuesRow.localTextPrefix; }
        protected getService() { return MFGInspectionValuesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}